import { createBrowserClient } from '@supabase/ssr'

/**
 * Anon client for Client Components in the admin panel.
 * Session is managed via cookies (set by middleware).
 */
export function createBrowserSupabaseClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  )
}
